<template>
  <div class="register-container" >
    <div class="close-form-btn" @click="cancel"></div>
    <form @submit.prevent>
      <div class="form-inner" :class="{scroll: focus}">
        <dl>
          <dt>スポット名称</dt>
          <dd>
            <input class="input-text" type="text" v-model="name" @input="formErrorName = false" @focus="focus = true" @blur="focus = false">
            <p v-show="formErrorName" class="alert">入力してください</p>
          </dd>
        </dl>
        <dl>
          <dt>概要</dt>
          <dd>
            <textarea class="textarea" v-model="description" @input="formErrorDescription = false" @focus="focus = true" @blur="focus = false"></textarea>
            <p v-show="formErrorDescription" class="alert">入力してください</p>
          </dd>
        </dl>
        <dl class="inline width-70">
          <dt>写真アップロード</dt>
          <dd id="fileInputBox">
            <input id="fileData" type="file" name="fileData" ref="file" accept="image/*" multiple @click="resetImageUploader()" @change="uploadFile($event)"/>
          </dd>
        </dl>
        <dl class="inline width-30">
          <dt>写真の月</dt>
          <dd>
            <select class="select-box" v-model="month">
              <option v-for="n in 12" v-bind:value="n" :key="n">{{ n }}月</option>
            </select>
          </dd>
        </dl>
        <dl class="inline width-100">
          <dd>
            <p v-if="formErrorPostImage" class="alert">{{error}}</p>
          </dd>
        </dl>
        <!-- START: Spot tags -->
        <dl class="inline width-100">
          <dt>タグ<span style="font-size: 10px;"> (タグ１, タグ 2, タグ３)</span></dt>
          <dd>
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              :allow-edit-tags="true"
              :avoid-adding-duplicates="true"
              :add-on-key="[13, ':', ';', ',']"
              placeholder=" "
              class="tags-input"
              @tags-changed="newTags => tags = newTags"
            >
              <div
                slot="autocomplete-item"
                slot-scope="props"
                class="my-item"
                @click="props.performAdd(props.item)"
              >
                {{ props.item.text }}
              </div>
              <div
                slot="tag-left"
                slot-scope="props"
                class="my-tag-left"
                @click="props.performOpenEdit(props.index)"
              >
              </div>
            </vue-tags-input>
          </dd>
        </dl>
        <!-- END: Spot tags -->
        <dl>
          <dt>写真コメント</dt>
          <dd>
            <input class="input-text" type="text" v-model="comment" @input="formErrorComment = false" @focus="focus = true" @blur="focus = false">
            <p v-show="formErrorComment" class="alert">入力してください</p>
          </dd>
        </dl>
        <div id="previewContainer"  v-bind:key="file.id" v-for="(file, index) in files">
          <img id="previewImage" :src="file.src"><span>{{file.file.name}}</span>
          <div class="deleteButton" @click="removeFile(index)"></div>
        </div>
        <div class="btn-wrap">
          <button type="cancel" class="cancel-button" @click="cancel">キャンセル</button>
          <button type="submit" class="save-button" @click="save">登録</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import utils from '../../../utils/vue/Utils'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'register-form',
  components: {
    VueTagsInput
  },
  data () {
    return {
      name: '',
      description: '',
      postImages: [],
      error: '',
      comment: '',
      formErrorName: false,
      formErrorDescription: false,
      formErrorPostImage: false,
      formErrorComment: false,
      focus: false,
      files: [],
      resizedImages: [],
      month: new Date().getMonth() + 1,
      tag: '',
      tags: []
    }
  },
  methods: {
    resetImageUploader () {
      this.$refs.file.value = ''
      this.month = new Date().getMonth() + 1
    },
    uploadFile (e) {
      console.log(e)
      this.files = []
      this.resizedImages = []
      this.formErrorPostImage = false

      if (e.target.files.length > this.constant.upload.maxFile) {
        document.getElementById('fileData').value = ''
        this.error = `${this.constant.upload.maxFile}枚以内の画像を選択してください`
        this.formErrorPostImage = true
      }

      // Get files upload data
      for (var i = 0; i < e.target.files.length; i++) {
        var file = e.target.files[i]
        var image = { id: i, src: URL.createObjectURL(file), file: file, month: '1' }
        this.files.push(image)
      }
      this.postImages = e.target.files
    },
    removeFile (index) {
      var listFile = []
      this.formErrorPostImage = false
      this.files.splice(index, 1)

      for (var i = 0; i < this.files.length; i++) {
        listFile.push(this.files[i].file)
      }
      this.postImages = listFile
    },
    async save () {
      // Form input validation
      this.formErrorName = false
      this.formErrorDescription = false
      this.formErrorPostImage = false
      this.formErrorComment = false
      if (this.name === '') {
        this.formErrorName = true
      }
      if (this.description === '') {
        this.formErrorDescription = true
      }

      if (this.comment === '') {
        this.formErrorComment = true
      }

      if (this.postImages.length === 0) {
        this.error = '画像を選択してください'
        this.formErrorPostImage = true
      }

      if (this.formErrorName || this.formErrorDescription || this.formErrorPostImage || this.formErrorComment) {
        return
      }

      // Resize Images
      for (var i = 0; i < this.postImages.length; i++) {
        const url = await this.resizeImage(this.postImages[i])
        this.resizedImages.push(this.dataURItoFile(url))
      }

      this.createArticle()
    },
    createArticle () {
      // Set up api parameters
      let params = new FormData()
      params.append('name', this.name)
      params.append('comment', this.comment)
      if (this.getItem('user_id')) {
        params.append('user_id', this.getItem('user_id'))
      }
      params.append('description', this.description)
      params.append('location_lat', this.store.getters['saveLatLng/getLat'])
      params.append('location_lon', this.store.getters['saveLatLng/getLng'])
      Array.from(this.postImages).forEach(_ => {
        params.append('months[]', this.month)
      })

      this.tags.forEach(_ => params.append('tags[]', _.text))

      this.resizedImages.forEach(_ => {
        params.append('post_images[]', _)
      })

      // Call API to upload files to server
      this.postUserApi('articles/post', params).then((res) => {
        this.resetForm()

        this.store.dispatch('centerLatLng/setLat', this.store.getters['saveLatLng/getLat'])
        this.store.dispatch('centerLatLng/setLng', this.store.getters['saveLatLng/getLng'])

        this.showModal(this.constant.modal.util)
        this.store.dispatch('modal/setMessage1', '保存しました')
        this.store.dispatch('menu/setForm', false)

        this.getMarkerCoordinates()
      }).catch((error) => {
        console.error(error)
      })
    },
    cancel () {
      // アニメーションの関係上手動で初期化
      this.resetForm()
      this.store.dispatch('menu/setForm', false)
    },
    resetForm () {
      // Reset form input
      this.month = new Date().getMonth() + 1
      this.name = ''
      this.description = ''
      this.files = []
      this.postImages = []
      this.resizedImages = []
      document.getElementById('fileData').value = ''
      this.error = ''
      this.comment = ''
      this.tag = ''
      this.tags = []
      this.formErrorName = false
      this.formErrorDescription = false
      this.formErrorPostImage = false
      this.formErrorComment = false
    }
  },
  mixins: [utils]
}
</script>

<style lang="scss" scoped src="../scss/RegisterForm.scss"></style>



// WEBPACK FOOTER //
// src/components/register/vue/RegisterForm.vue